import { routes as portfolioRoutes } from './portfolio'
import { routes as resourceRoutes } from './routes'
import { routes as stockOrderRoutes } from './stock-orders'

export const routes = {
  ...portfolioRoutes,
  ...resourceRoutes,
  ...stockOrderRoutes,
} as const
